/**
 * Hand-written model for OpenAPI `format: "time"` fields (HH:mm:ss wire format).
 * Source of truth lives here in api-config/ (tracked in git).
 * Copied to api-client/models/ by the generateApiClient script after generation.
 *
 * Using Date matches what MUI TimePicker produces, so no conversion is needed
 * in consumer code. Serialization uses locale-independent arithmetic instead
 * of toTimeString() which varies by browser locale.
 */

export type TimeDate = Date;

export function TimeDateFromJSON(json: any): TimeDate {
  return TimeDateFromJSONTyped(json, false);
}

export function TimeDateFromJSONTyped(json: any, _ignoreDiscriminator: boolean): TimeDate {
  if (json == null) {
    return json;
  }
  const [hours = 0, minutes = 0, seconds = 0] = (json as string).split(":").map(Number);
  const date = new Date(0);
  date.setHours(hours, minutes, seconds, 0);
  return date;
}

export function TimeDateToJSON(value?: TimeDate | null): any {
  return TimeDateToJSONTyped(value, false);
}

export function TimeDateToJSONTyped(value?: TimeDate | null, _ignoreDiscriminator: boolean = false): any {
  if (value == null) {
    return value;
  }
  return `${String(value.getHours()).padStart(2, "0")}:${String(value.getMinutes()).padStart(2, "0")}:${String(value.getSeconds()).padStart(2, "0")}`;
}
